import React from 'react';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { Content } from '../../infrastructure/content';

export const ExitButton = ({ saveEnabled, exitButtonText, onClick }) => (
  <Content>
    {({ saveAndExit, cancelButtonText }) => (
      <NavigationButton.Tertiary
        labelText={exitButtonText ? exitButtonText : saveEnabled ? saveAndExit : cancelButtonText}
        onClick={onClick}
      />
    )}
  </Content>
);
